<template>
  <div>
    <el-card>
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="font-weight:600;">营销策略</div>
        <el-button type="primary" @click="openAdd">新增规则</el-button>
      </div>
      <el-table :data="rules" style="width:100%;margin-top:16px;">
        <el-table-column prop="类型" label="类型" width="100" />
        <el-table-column prop="名称" label="策略名称" min-width="150" />
        <el-table-column prop="策略内容" label="策略内容" min-width="180" />
        <el-table-column label="有效期" width="200">
          <template slot-scope="scope">
            {{ scope.row.开始日期 }} 至 {{ scope.row.结束日期 }}
          </template>
        </el-table-column>
        <el-table-column prop="状态" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.状态 === '启用' ? 'success' : 'info'">{{ scope.row.状态 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="备注" label="备注" show-overflow-tooltip />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="isEdit ? '编辑规则' : '新增规则'" :visible.sync="dialogVisible" width="900px">
      <el-form :model="form" ref="formRef" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="类型">
              <el-radio-group v-model="form.type">
                <el-radio label="fullreduction">满减</el-radio>
                <el-radio label="fullgift">买赠</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="启用">启用</el-radio>
                <el-radio label="停用">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="名称">
              <el-input v-model="form.name" placeholder="请输入策略名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="满" v-if="form.type === 'fullreduction'">
              <div style="display: flex; align-items: center;">
                <el-input-number
                  v-model="form.thresholdAmount"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  style="width: 150px;"
                />
                <span style="margin: 0 10px;">减</span>
                <el-input-number
                  v-model="form.discountAmount"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  style="width: 150px;"
                />
              </div>
            </el-form-item>
            <el-form-item label="买" v-else>
              <div style="display: flex; align-items: center;">
                <el-input-number
                  v-model="form.thresholdAmount"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  style="width: 150px;"
                />
                <span style="margin: 0 10px;">赠</span>
                <el-input-number
                  v-model="form.discountAmount"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  style="width: 150px;"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="form.start_date"
                type="date"
                placeholder="选择开始日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="form.end_date"
                type="date"
                placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品列表">
          <div style="margin-bottom: 10px;">
            <el-button type="primary" size="small" @click="openProductSelect">添加商品</el-button>
          </div>
          <el-table :data="form.products" style="width: 100%;" border height="300">
            <el-table-column prop="sku_no" label="货号" width="120"></el-table-column>
            <el-table-column prop="sku_name" label="商品名称" min-width="200"></el-table-column>
            <el-table-column prop="sku_spec" label="规格" width="150"></el-table-column>
            <el-table-column prop="sell_price" label="价格" width="100"></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="removeProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 商品选择弹窗 -->
    <el-dialog title="选择商品" :visible.sync="productSelectVisible" width="1000px" top="5vh" append-to-body>
      <div style="margin-bottom: 15px; display: flex; gap: 10px;">
        <el-input v-model="searchKeyword" placeholder="输入商品名称搜索" style="width: 250px;" clearable @clear="handleSearch"
          @keyup.enter.native="handleSearch"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      </div>
      <el-table :data="filteredProducts" v-loading="loadingProducts" style="width: 100%" height="500"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column label="图片" width="80">
          <template slot-scope="scope">
            <el-image v-if="scope.row.sku_picture" :src="scope.row.sku_picture" style="width:50px;height:50px;"
              fit="cover" />
            <div v-else
              style="width:50px;height:50px;background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">
              无图</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="sku_no" label="货号" width="120"></el-table-column>
        <el-table-column prop="sku_name" label="商品名称" min-width="200"></el-table-column>
        <el-table-column prop="sku_spec" label="规格" width="180"></el-table-column>
        <el-table-column prop="sell_price" label="价格" width="100"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="productSelectVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProductSelection">确认选择</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
/* 修复Element UI单选按钮的可访问性问题 */
.el-radio__original {
  /* 隐藏原生radio但保持可访问性 */
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}

/* 确保焦点状态可见 */
.el-radio:focus-within .el-radio__label {
  outline: 2px solid #409eff;
  outline-offset: 2px;
}
</style>

<script>
import { StrategyList, StrategyEdit, StrategyRemove, StrategySkuSearchSku } from '@/api/api.js'

export default {
  name: 'AdminMarketing',
  data() {
    return {
      rules: [],
      dialogVisible: false,
      productSelectVisible: false,
      isEdit: false,
      editingId: null,
      form: {
        type: 'fullreduction',
        name: '',
        thresholdAmount: 0,
        discountAmount: 0,
        status: '启用',
        start_date: '',
        end_date: '',
        remark: '',
        products: [] // 商品列表，包含所有适用该策略的商品
      },
      products: [],
      filteredProducts: [],
      searchKeyword: '',
      loadingProducts: false,
      selectedProducts: [] // 用于存储商品选择弹窗中选中的商品
    }
  },
  created() {
    this.fetchStrategyList()
  },
  methods: {
    async fetchStrategyList() {
      try {
        const res = await StrategyList({})
        if (res && res.data) {
          this.rules = res.data
        }
      } catch (e) {
        console.error(e)
        this.rules = []
      }
    },
    openAdd() {
      this.isEdit = false
      this.editingId = null
      this.form = {
        type: 'fullreduction',
        name: '',
        thresholdAmount: 0,
        discountAmount: 0,
        status: '启用',
        start_date: '',
        end_date: '',
        remark: '',
        products: []
      }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.isEdit = true
      this.editingId = row.id

      const isFullReduction = row.类型 === '满减' || row.type === 'fullreduction'

      let products = []
      const rawProducts = row.策略商品 || row.products
      if (rawProducts) {
        if (Array.isArray(rawProducts)) {
          products = rawProducts
        } else if (typeof rawProducts === 'string') {
          try {
            const parsed = JSON.parse(rawProducts)
            if (Array.isArray(parsed)) {
              products = parsed
            } else if (parsed) {
              products = [parsed]
            }
          } catch (e) {
            products = []
          }
        }
      }

      products = this.normalizeProducts(products)

      this.form = {
        type: isFullReduction ? 'fullreduction' : 'fullgift',
        name: row.名称 || row.name || '',
        thresholdAmount: row.买 || row.buy_count || row.thresholdAmount || 0,
        discountAmount: row.赠 || row.free_count || row.discountAmount || 0,
        status: row.状态 || row.status || '启用',
        start_date: row.开始日期 || row.start_date || '',
        end_date: row.结束日期 || row.end_date || '',
        remark: row.备注 || row.remark || '',
        products
      }

      this.dialogVisible = true
    },
    normalizeProducts(rawList) {
      if (!Array.isArray(rawList)) return []
      return rawList.map(item => ({
        id: item.id || '',
        sku_no: item['货号'] || item.sku_no || '',
        sku_name: item['品名'] || item.sku_name || '',
        sku_spec: item['规格'] || item.sku_spec || '',
        sell_price: item['零售价'] || item.sell_price || 0,
        sku_picture: item['图片'] || item.sku_picture || null,
        manufacturer: item['生产厂家'] || item.manufacturer || '',
        approval_number: item['批准文号'] || item.approval_number || '',
        unit: item['单位'] || item.unit || ''
      }))
    },
    async openProductSelect() {
      this.productSelectVisible = true
      this.loadingProducts = true
      this.selectedProducts = []
      const strategyId = this.isEdit ? this.editingId : 0
      try {
        const res = await StrategySkuSearchSku({
          strategy_id: strategyId,
          keyword: this.searchKeyword
        })
        if (res && res.data) {
          const list = this.normalizeProducts(res.data)
          this.products = list
          this.filteredProducts = list
        } else {
          this.products = []
          this.filteredProducts = []
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingProducts = false
      }
    },
    async handleSearch() {
      this.loadingProducts = true
      const strategyId = this.isEdit ? this.editingId : 0
      try {
        const res = await StrategySkuSearchSku({
          strategy_id: strategyId,
          keyword: this.searchKeyword
        })
        if (res && res.data) {
          const list = this.normalizeProducts(res.data)
          this.products = list
          this.filteredProducts = list
        } else {
          this.products = []
          this.filteredProducts = []
        }
      } catch (e) {
        console.error(e)
        this.filteredProducts = []
      } finally {
        this.loadingProducts = false
      }
    },
    handleSelectionChange(selection) {
      this.selectedProducts = selection
    },
    confirmProductSelection() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请选择商品')
        return
      }

      // 将选中的商品添加到表单的商品列表中，避免重复添加
      let addedCount = 0
      this.selectedProducts.forEach(product => {
        const exists = this.form.products.some(p => {
          const skuMatch = p.sku_no && product.sku_no && p.sku_no === product.sku_no
          const idMatch = p.id && product.id && p.id === product.id
          return skuMatch || idMatch
        })
        if (!exists) {
          this.form.products.push(product)
          addedCount++
        }
      })

      this.productSelectVisible = false
      if (addedCount > 0) {
        this.$message.success(`已成功添加 ${addedCount} 个商品`)
      } else {
        this.$message.info('选中的商品已在列表中')
      }
      this.selectedProducts = [] // 清空已选中的商品
    },
    removeProduct(product) {
      const index = this.form.products.findIndex(p => {
        const skuMatch = p.sku_no && product.sku_no && p.sku_no === product.sku_no
        const idMatch = p.id && product.id && p.id === product.id
        return skuMatch || idMatch
      })
      if (index !== -1) {
        this.form.products.splice(index, 1)
        this.$message.success('已删除商品')
      }
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return

        // Construct payload for StrategyEdit
        const payload = {
          id: this.isEdit ? this.editingId : 0,
          strategy_type: this.form.type === 'fullreduction' ? '满减' : '买赠',
          name: this.form.name,
          status: this.form.status === '启用' ? 1 : 0,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          buy_count: this.form.thresholdAmount,
          free_count:  this.form.discountAmount,
          remark: this.form.remark,
          products: this.form.products
            .map(p => p.sku_no)
            .filter(sku => !!sku)
        }

        StrategyEdit(payload)
          .then(res => {
            if (res.code === 200 || res.status === 200 || res.success) {
              this.$message.success(this.isEdit ? '更新成功' : '新增成功')
              this.fetchStrategyList()
              this.dialogVisible = false
            } else {
              this.$message.error(res.msg || (this.isEdit ? '更新失败' : '新增失败'))
            }
          })
          .catch(err => {
            console.error(err)
            this.$message.error('请求失败')
          })
      })
    },
    remove(id) {
      this.$confirm('确认删除该规则吗？', '提示', { type: 'warning' })
        .then(() => {
          StrategyRemove({ strategy_id: id }).then(res => {
            if (res.code === 200 || res.status === 200 || res.success) {
              this.$message.success('删除成功')
              this.fetchStrategyList()
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          }).catch(err => {
            console.error(err)
            this.$message.error('删除失败')
          })
        })
        .catch(() => { })
    }
  }
}
</script>

<style></style>
